<template>
  <div class="content">

    <!-- Nagłówek z przyciskiem rozwijania filtrów, widoczny tylko dla kroków 1 i 2 -->
    <!-- <h2
      data-bs-toggle="collapse"
      :href="`#current-filters`"
      role="button"
      aria-expanded="true"
      :aria-controls="`current-filters`"
      class="margin-0"
      v-if="current.step < 3"
    >
    {{ t('filters').toUpperCase() }}
    </h2> -->
    <!-- Pasek akcji kroku: przełącznik mapy, wskaźnik kroku, akcje nawigacyjne -->
    <div class="ds-toolbar actions-down">
      <!-- Przycisk powrotu (widoczny jeśli nie jesteśmy na 1 kroku) — przy lewej
           krawędzi paska, DALEJ przy prawej. Tak samo w archiwum i statystykach. -->
      <button class="ds-btn ds-btn--secondary btn-prev" v-if="current.step > 1" @click="previousStep()">
        <span class="ds-btn__arrow" aria-hidden="true">&#8592;</span>
        {{ t('back2').toUpperCase() }}
      </button>

      <label class="ds-switch" for="location-view-toggle" v-if="current.step === 1 && !isSG">
        <span class="ds-switch__label">{{ t('map').toUpperCase() }}</span>
        <input id="location-view-toggle" type="checkbox" v-model="useMapLocationList" />
        <span class="ds-switch__track"></span>
      </label>

      <div class="ds-toolbar__spacer"></div>

      <!-- Wskaźnik postępu kreatora (kroki wyboru filtrów) -->
      <div class="ds-stepper" v-if="current.step < 3">
        <span class="ds-stepper__label">
          {{ t('step-indicator', { current: current.step, total: 2 }) }}
        </span>
        <span class="ds-stepper__dots" aria-hidden="true">
          <span class="ds-stepper__dot" :class="{ 'is-active': current.step === 1 }"></span>
          <span class="ds-stepper__dot" :class="{ 'is-active': current.step === 2 }"></span>
        </span>
      </div>

      <div class="ds-toolbar__spacer"></div>

      <!-- Przycisk "dalej"/"zastosuj" (widoczny jeśli nie jesteśmy na ostatnim kroku) -->
      <button
          class="ds-btn ds-btn--primary btn-next"
          v-if="current.step < 3"
          @click="nextStep()"
          :disabled="!canGoNext"
      >
        {{ current.step < 2 ? t('next').toUpperCase() : t('apply').toUpperCase() }}
        <span class="ds-btn__arrow" aria-hidden="true">&#8594;</span>
      </button>
    </div>

    <!-- Krok 1: Filtry preselekcji, wybór lokalizacji, kategorii pojazdu, pasa itd.
         Układ dwustrefowy: po lewej miejsce pomiaru (na całą wysokość), po prawej
         dwa rzędy paneli o proporcjach odczytanych z referencji. -->
    <div v-if="current.step == 1" class="step1" :class="{ 'step1--sg': shouldHideLocation }">
      <div class="step1__locations">
        <component :is="locationListComponent" :store="filtersStore" />
      </div>

      <div class="step1__right">
        <div class="step1__row step1__row--top" v-if="!shouldHideLocation">
          <vehicle-categories :store="filtersStore" />
          <lane-numbers :store="filtersStore" />
        </div>

        <div class="step1__row step1__row--bottom">
          <violation-list
            v-if="!shouldHideLocation"
            :store="filtersStore"
            :step="current.step"
          />
          <sort-by :store="filtersStore" />
        </div>
      </div>
    </div>

    <!-- Krok 2: Filtry danych pojazdu -->
    <div v-if="current.step == 2" class="step2-wrap">
      <current-vehicle-data />
    </div>

    <!-- Krok 3 i dalej: Wyniki, lista pojazdów, spinner ładowania, możliwość wrócenia -->
    <div v-if="current.step > 2">
      <!-- Filtry w formie collapse (można je zwinąć/rozwinąć) -->
      <div class="collapse" :id="`current-filters`">
        <div class="step1">
          <div class="step1__locations">
            <component :is="locationListComponent" :store="filtersStore" />
          </div>
          <div class="step1__right">
            <div class="step1__row step1__row--top">
              <vehicle-categories :store="filtersStore" />
              <lane-numbers :store="filtersStore" />
            </div>
            <div class="step1__row step1__row--bottom">
              <violation-list :store="filtersStore" />
              <sort-by :store="filtersStore" />
            </div>
          </div>
        </div>
        <!-- Przycisk: Zastosuj filtry -->
        <div class="ds-toolbar justify-content-end">
          <button
            class="ds-btn ds-btn--primary btn-next"
            @click="current.nextStep()"
            :disabled="!hasSelectedLocations"
            :aria-controls="`current-filters`"
            data-bs-toggle="collapse"
            :href="`#current-filters`"
          >
          {{ t('apply').toUpperCase() }}
          </button>
        </div>
      </div>
      <div class="content">
        <!-- Przycisk powrotu do poprzedniego kroku -->
        <!-- <div class="d-flex justify-content-between actions">
          <button class="btn-prev" @click="current.previousStep()">
            {{ t('back2').toUpperCase() }}
          </button>
        </div> -->
        <!-- Spinner ładowania + informacja o zbyt długim czasie oczekiwania -->
        <spinner-element
          :loading="loading"
          :loading-to-long="loadingToLongSeconds > 30"
        />
        <!-- Lista pojazdów aktualnych -->
        <vehicle-list
            :data-service="vehService"
            :vehicle-list="current.vehicles"
            :timer-visible="false"
            details-path="vehicle"
            @openDetails="goToDetailsView"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { useCurrentFiltersStore } from "@/stores/currentFilters"; // Store filtrów
import CurrentMeasurementsService from "@/services/CurrentMeasurementsService"; // Serwis API
import VehicleList from "@/components/VehicleList";
import LocationList from "./filters/LocationList.vue";
import LocationList2 from "./filters/LocationList2.vue";
import LaneNumbers from "./filters/LaneNumbers.vue";
import VehicleCategories from "./filters/VehicleCategories.vue";
import ViolationList from "./filters/ViolationList.vue";
import SortBy from "./current/SortBy.vue";
import SpinnerElement from "./SpinnerElement.vue";
import CurrentVehicleData from "./current/CurrentVehicleData.vue";
import moment from "moment";
import { useCurrentStore } from "@/stores/current";
import { useRoute } from "vue-router";
import { computed } from "vue";
import { useUserStore } from "@/stores/user.store";
import { useAuthStore } from "@/stores/auth.store";
import { isSG } from "@/config/appVersion";

export default {
  name: "CurrentMeasurement",
  components: {
    LocationList,
    LocationList2,
    LaneNumbers,
    VehicleCategories,
    ViolationList,
    VehicleList,
    SortBy,
    SpinnerElement,
    CurrentVehicleData,
  },
  setup() {
    // Inicjalizacja Pinia stores oraz obiektów pomocniczych
    const current = useCurrentStore();
    const filtersStore = useCurrentFiltersStore();
    const route = useRoute();

    const shouldHideLocation = computed(() => isSG);

    const auth = useAuthStore();

    return { filtersStore, current, route, shouldHideLocation, auth, isSG };
  },
  data() {
    return {
      loading: false, // Czy trwa ładowanie pojazdów
      loadingToLongSeconds: 0, // Licznik do komunikatu o długim ładowaniu
      lastVehicleId: null, // Ostatni ID pojazdu (do różnicowania nowych danych)
      moment: moment,
      vehService: CurrentMeasurementsService, // Serwis danych pojazdów
      currentOrder: "desc", // Kierunek sortowania (nieużywane tutaj)
      currentLocationList: this.filtersStore.filters.locations, // Lista lokalizacji z filtrów
      momentDiffServer: 0, // Różnica czasu serwer-klient (synchronizacja czasowa)
      withClearOnSuccess: false, // Czy czyścić dane po sukcesie (nieużywane)
      lastId: null, // Ostatni znany ID pojazdu (pomocnicze przy pobieraniu)
      clockOffsetMs: 0,        // <-- wyrównanie zegara serwer - klient (ms)
      userStore: useUserStore(),
      useMapLocationList: false,
      reloading: false, // Trwa przeładowanie listy po zmianie filtrów (blokuje cykliczne checkData)
    };
  },
  computed: {
    locationListComponent() {
      return this.isSG ? "LocationList" : (this.useMapLocationList ? "LocationList2" : "LocationList");
    },
    // Czy wybrano przynajmniej jedną lokalizację (wymagane do przejścia dalej)
    hasSelectedLocations() {
      const locs = this.filtersStore.filters?.locations;
      return Array.isArray(locs) && locs.length > 0;
    },
    // Blokada przycisku "Dalej" — na 1 kroku wymagany wybór lokalizacji
    canGoNext() {
      if (this.current.step !== 1) return true;
      return this.hasSelectedLocations;
    },
  },
  created() {
    // Nasłuchiwanie na zmiany kroku w store (przełączanie widoków)
    this.$watch(() => this.current.step, (newVal) => {
      this.setStep(newVal);
    }, { immediate: true });

    // Nasłuchiwanie na zmiany filtrów (panel boczny — ikona kosza, odznaczenie lokalizacji).
    // Na kroku wyników trzeba przeładować listę od zera: `checkData` dociąga tylko pojazdy
    // nowsze od `lastId` i tylko wtedy, gdy backend zgłosi `refresh`, więc bez tego na ekranie
    // wisiały wyniki dla poprzednich filtrów.
    this.$watch(() => this.filtersStore.filters, () => {
      if (this.current.step > 2) {
        this.reloadVehicles();
      }
    }, { deep: true });
  },
  methods: {
    goToDetailsView(vehicle) {
      const path = `/vehicle/${vehicle.id}/${vehicle.location.id}`;
      this.$router.push({
        path,
        query: {
          backTo: this.$route.fullPath,
        },
      });
    },
    // Obsługa zmiany kroku - ustawienie odpowiedniego widoku i zachowań
    async setStep(newVal) {
      if (newVal === 1) {
        // Krok 1 - czyszczenie, stopowanie timerów, reset danych
        this.current.stopIntervals();
        this.current.setVehicles([], this.momentDiffServer);
        this.loading = false;
        this.momentDiffServer = 0;
      } 
      if(newVal === 2) {
        // Krok 2 - tylko stopowanie timerów, brak ładowania
        this.current.stopIntervals();
        this.loading = false;
      }
      if (newVal === 3) {
        // Krok 3 - ładowanie danych, uruchomienie cyklicznego sprawdzania
        this.loading = true;

        // Czyścimy listę z poprzedniego przebiegu — bez tego pojazdy pobrane przy
        // wcześniejszych filtrach wisiałyby na ekranie aż minie ich checkpointTime,
        // bo `checkData` filtruje istniejącą listę tylko po czasie, nie po totalLoad/violation/itp.
        this.current.setVehicles([], 0);
        this.lastId = null;

        await this.userStore.self?.();
        const addSec = this.userStore?.preferences?.checkpointAdditionalTime || 0;
        this.momentDiffServer = Number(addSec) * 1000; // na ms

        this.checkData();

        if (!this.current.getIntervalCheck()) {
          this.current.startIntervalCheck(setInterval(() => {
            this.checkData();
          }, 1000));
        }
      }
    },
    // Oblicz różnicę czasu systemowego między serwerem i klientem
    // getEqualizationTime(counters) {
    //   try {
    //     const serverSystemTime = new Date(counters.currentSystemTime);
    //     const clientSystemTime = new Date();
    //     this.momentDiffServer = serverSystemTime - clientSystemTime;
    //     return this.momentDiffServer;
    //   } catch (error) {
    //     console.error('Błąd podczas obliczania czasu równoważenia:', error);
    //     return 0;
    //   }
    // },
    getEqualizationTime(counters) {
      try {
        const serverSystemTime = new Date(counters.currentSystemTime).getTime();
        const clientSystemTime = Date.now();
        this.clockOffsetMs = serverSystemTime - clientSystemTime; // tylko offset zegara
        return this.clockOffsetMs;
      } catch (error) {
        console.error('Błąd podczas obliczania czasu równoważenia:', error);
        this.clockOffsetMs = 0;
        return 0;
      }
    },
    // Pobierz najnowsze dane, filtruj i aktualizuj store oraz stan ładowania
    // async checkData() {
    //   const now = Date.now() + this.momentDiffServer;

    //   // Odfiltruj pojazdy, które już przekroczyły checkpointTime (nieaktualne)
    //   const filteredVehicles = this.current.vehicles.filter(vehicle => {
    //     const checkpointTimestamp = new Date(vehicle.checkpointTime).getTime();
    //     return checkpointTimestamp > now;
    //   });

    //   // Jeśli lista pojazdów się zmieniła - zaktualizuj store
    //   if (filteredVehicles.length !== this.current.vehicles.length) {
    //     this.current.setVehicles(filteredVehicles, this.momentDiffServer);
    //     if (filteredVehicles.length === 0) {
    //       this.loading = true;
    //     }
    //   }

    //   // Sprawdź, czy wybrano jakąś lokalizację
    //   if (this.filtersStore.selectedLocation.length > 0) {
    //     const selectedIds = this.filtersStore.selectedLocation.map(loc => loc.id);
    //     if (!selectedIds.length) {
    //       return;
    //     }

    //     // Sprawdź czy lokalizacje wymagają odświeżenia
    //     let checkLocations = await CurrentMeasurementsService.checkLocations(selectedIds);
    //     if (checkLocations.refresh === true) {
    //       // Pobierz liczniki serwera do synchronizacji czasu
    //       const counters = await CurrentMeasurementsService.getCounters(selectedIds);
    //       this.getEqualizationTime(counters);

    //       // Pobierz nowe pojazdy
    //       let vehicleList = [];
    //       vehicleList = await CurrentMeasurementsService.getVehicleList(this.lastId);

    //       const newVehicles = [];
    //       const now = Date.now() + this.momentDiffServer;
    //       vehicleList.forEach(vehicle => {
    //         const checkpointTimestamp = new Date(vehicle.checkpointTime).getTime();
    //         if (checkpointTimestamp > now) {
    //           // Dodaj tylko nieistniejące pojazdy (unikaj duplikatów)
    //           const existingIds = new Set(this.current.vehicles.map(v => v.id));
    //           if (!existingIds.has(vehicle.id)) {
    //             this.current.vehicles.unshift(vehicle);
    //             newVehicles.push(vehicle);
    //           }
    //           // Zaktualizuj lastId jeśli trzeba
    //           if (vehicle.id > this.lastId) {
    //             this.lastId = vehicle.id;
    //           }
    //           this.loading = false;
    //         }
    //       });

    //       // Jeśli pojawiły się nowe pojazdy - zaktualizuj licznik, odśwież UI, uruchom beep itd.
    //       if (newVehicles.length > 0) {
    //         this.current.setVehicles(this.current.vehicles, this.momentDiffServer);
    //         CurrentMeasurementsService.beep();

    //         // Aktualizacja licznika nowych pojazdów tylko poza stroną główną
    //         if (this.route.path !== '/') {
    //           this.current.queryCount++;
    //           CurrentMeasurementsService.setNewCarsNumber(this.current.queryCount);
    //         } else {
    //           this.current.queryCount = 0;
    //           CurrentMeasurementsService.setNewCarsNumber(this.current.queryCount);
    //         }
    //       }
    //     }
    //   }
    // },
    async checkData() {
      // W czasie przeładowania listy (zmiana filtrów) pomijamy cykl — inaczej dociągnięte
      // wcześniej pojazdy wróciłyby na listę po jej wyczyszczeniu.
      if (this.reloading) return;

      // "Teraz" w czasie serwera (wyrównanym)
      const nowAligned = Date.now() + this.clockOffsetMs;

      // 1) odfiltruj obecną listę po checkpoint + dodatkowe okno
      const filteredVehicles = this.current.vehicles.filter(vehicle => {
        const cp = new Date(vehicle.checkpointTime).getTime();
        // this.auth.heartbeat("current-measurement");
        return (cp + this.momentDiffServer) > nowAligned;
      });

      if (filteredVehicles.length !== this.current.vehicles.length) {
        this.current.setVehicles(filteredVehicles, this.momentDiffServer);
        if (filteredVehicles.length === 0) {
          this.loading = true;
        }
      }

      // 2) sprawdź lokalizacje i ew. pobierz nowe
      if (this.filtersStore.selectedLocation.length > 0) {
        const selectedIds = this.filtersStore.selectedLocation.map(loc => loc.id);
        if (!selectedIds.length) return;

        let checkLocations = await CurrentMeasurementsService.checkLocations(selectedIds);
        if (checkLocations.refresh === true) {
          // pobierz zegar serwera -> ustaw clockOffsetMs
          const counters = await CurrentMeasurementsService.getCounters(selectedIds);
          this.getEqualizationTime(counters);

          // pobierz listę nowych pojazdów
          const vehicleList = await CurrentMeasurementsService.getVehicleList(this.lastId);

          const newVehicles = [];
          const existingIds = new Set(this.current.vehicles.map(v => v.id));

          vehicleList.forEach(vehicle => {
            const cp = new Date(vehicle.checkpointTime).getTime();
            // dopuszczamy rekord tylko jeśli checkpoint+okno > now (serwerowo wyrównane)
            if ((cp + this.momentDiffServer) > (Date.now() + this.clockOffsetMs)) {
              if (!existingIds.has(vehicle.id)) {
                this.current.vehicles.unshift(vehicle);
                newVehicles.push(vehicle);
              }
              if (vehicle.id > this.lastId) this.lastId = vehicle.id;
              this.loading = false;
            }
          });

          if (newVehicles.length > 0) {
            this.current.setVehicles(this.current.vehicles, this.momentDiffServer);
            CurrentMeasurementsService.beep();
            this.auth.heartbeat("current-measurement");

            if (this.route.path !== '/') {
              this.current.queryCount++;
              CurrentMeasurementsService.setNewCarsNumber(this.current.queryCount);
            } else {
              this.current.queryCount = 0;
              CurrentMeasurementsService.setNewCarsNumber(this.current.queryCount);
            }
          }
        }
      }
    },
    // Przeładowanie listy pojazdów od zera dla aktualnych filtrów.
    // Wołane po zmianie filtrów na kroku wyników — pobiera dane bez czekania na `refresh`
    // z /current-vehicles/check (ten zwraca TRUE tylko gdy na stacji pojawił się nowy pojazd).
    async reloadVehicles() {
      this.reloading = true;

      try {
        // Czyścimy listę i znacznik ostatniego pojazdu — pobieramy pełny wynik dla nowych filtrów.
        this.current.setVehicles([], this.momentDiffServer);
        this.lastId = null;

        const selectedIds = this.filtersStore.selectedLocation.map((loc) => loc.id);
        if (!selectedIds.length) {
          // Bez lokalizacji nie ma czego pobierać (np. użytkownik usunął wszystkie stacje).
          this.loading = false;
          return;
        }

        this.loading = true;

        const counters = await CurrentMeasurementsService.getCounters(selectedIds);
        this.getEqualizationTime(counters);

        const vehicleList = await CurrentMeasurementsService.getVehicleList(null);

        const vehicles = [];
        vehicleList.forEach((vehicle) => {
          const cp = new Date(vehicle.checkpointTime).getTime();
          // Ta sama zasada co w checkData — pokazujemy tylko pojazdy przed checkpointem.
          if ((cp + this.momentDiffServer) > (Date.now() + this.clockOffsetMs)) {
            vehicles.push(vehicle);
            if (this.lastId === null || vehicle.id > this.lastId) {
              this.lastId = vehicle.id;
            }
          }
        });

        this.current.setVehicles(vehicles, this.momentDiffServer);
        // Spinner zostaje tylko wtedy, gdy nic nie pasuje do filtrów — czekamy na kolejne pojazdy.
        this.loading = vehicles.length === 0;
      } catch (error) {
        console.error("Błąd przeładowania listy pojazdów:", error);
      } finally {
        this.reloading = false;
      }
    },
    // Aktualizuj lokalny krok (np. po zmianie w store)
    // getCurrentStep() {
    //   this.step = this.current.step;
    // },
    // Przejdź do kolejnego kroku (wywołuje logikę store)
    nextStep() {
      if (!this.canGoNext) return;
      this.current.nextStep();
    },
    previousStep() { this.current.previousStep(); },
  },
};
</script>

<style scoped>
/* Zawartość widoku „Bieżący pomiar" — kroki kreatora filtrów + lista wyników. */
.content,
.step-content {
  width: 100%;
  min-height: 478px;
  scrollbar-gutter: stable;
}

/* --- pasek akcji kroku ---------------------------------------------------- */

.actions-down {
  background: var(--surface-primary);
}

/* --- krok 1: siatka paneli filtrów ---------------------------------------- */

/* Dwie strefy: miejsce pomiaru po lewej (na całą wysokość) i dwa rzędy paneli
   po prawej. Proporcje odczytane z referencji skali dla kolumny 1300 px:
   miejsce pomiaru : (kategorie + pasy) ≈ 444 : 572, w rzędzie górnym
   kategorie : pasy ≈ 397 : 175, w dolnym przekroczenia : sortowanie ≈ 1 : 1.
   Wszędzie `minmax(0, …)`, żeby żaden panel nie rozpychał layoutu. */
.step1 {
  display: grid;
  grid-template-columns: minmax(0, 444fr) minmax(0, 572fr);
  gap: var(--spacing-md);
  align-items: start;
  padding: var(--spacing-md);
  background: var(--surface-secondary);
}

/* Panel miejsca pomiaru ma wysokość swojej treści — wiersze lokalizacji mają stałą
   wysokość (`LocationList.vue`), więc panel kończy się pod ostatnią lokalizacją,
   bez pustego pasma w środku. */
.step1__locations {
  min-width: 0;
}

.step1__right {
  display: grid;
  grid-template-rows: auto auto;
  gap: var(--spacing-md);
  min-width: 0;
}

.step1__row {
  display: grid;
  gap: var(--spacing-md);
  align-items: start;
  min-width: 0;
}

/* kategorie pojazdów | pasy ruchu */
.step1__row--top {
  grid-template-columns: minmax(0, 397fr) minmax(0, 175fr);
}

/* przekroczenia % | sortowanie */
.step1__row--bottom {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
}

/* Wariant SG: kategorie, pasy i przekroczenia są ukryte — po prawej zostaje
   samo sortowanie, więc dolny rząd ma jedną kolumnę. */
.step1--sg .step1__row--bottom {
  grid-template-columns: minmax(0, 1fr);
}

/* --- krok 2: formularz danych pojazdu ------------------------------------- */

.step2-wrap {
  padding: var(--spacing-md);
  background: var(--surface-secondary);
}
</style>
